module.exports = __webpack_public_path__ + "static/img/image010.24171ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image010.png
// module id = uRzv
// module chunks = 1